import React from "react";
import { Button } from "@mui/material";

const ButtonLink = ({ onClick, label }) => {
    return (
        <Button
            color="inherit"
            onClick={onClick}
            sx={{
                textDecoration: "none",
                background: "none",
                padding: 0,
                "&:hover": {
                    background: "none",
                    textDecoration: "underline",
                }
            }}
        >
            {label}
        </Button>
    );
}

export default ButtonLink;
